/*
* Copyright (c) 2009-2022. Authors: see NOTICE file.
*
* Licensed under the Apache License, Version 2.0 (the "License");
* you may not use this file except in compliance with the License.
* You may obtain a copy of the License at
*
*      http://www.apache.org/licenses/LICENSE-2.0
*
* Unless required by applicable law or agreed to in writing, software
* distributed under the License is distributed on an "AS IS" BASIS,
* WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
* See the License for the specific language governing permissions and
* limitations under the License.
*/

import Vue from 'vue';
import VueI18n from 'vue-i18n';

Vue.use(VueI18n);

// UI-7 A10: persist the user's explicit language choice across reloads.
const STORED_LOCALE_KEY = 'ims-locale';
function storedLocale() {
  try {
    return window.localStorage.getItem(STORED_LOCALE_KEY) || null;
  } catch (e) {
    return null;
  }
}

export default new VueI18n({
  locale: storedLocale() || 'en',
  fallbackLocale: 'en',
  messages: {
    'en': require('./locales/json/en.i18n.json'),
    'es': require('./locales/json/es.i18n.json'),
    'fr': require('./locales/json/fr.i18n.json'),
    'nl': require('./locales/json/nl.i18n.json'),
    'ro': require('./locales/json/ro.i18n.json'),
    'de': require('./locales/json/de.i18n.json'),
    'id': require('./locales/json/id.i18n.json'),
    'it': require('./locales/json/it.i18n.json'),
    'pt': require('./locales/json/pt.i18n.json')
  }
});

export const changeLanguageMixin = {
  methods: {
    // persist=true  → explicit user choice from the navbar selector (saved to
    //                 localStorage, wins over later implicit account-locale syncs).
    // persist=false → implicit sync (e.g. from the account locale); a previously
    //                 stored explicit choice takes precedence so it survives reloads.
    changeLanguage(language, persist = false) {
      let locale;
      if (persist) {
        locale = language || this.$i18n.fallbackLocale;
      } else {
        locale = storedLocale() || language || this.$i18n.fallbackLocale;
      }
      locale = locale.toLowerCase();
      this.$i18n.locale = locale;
      this.$moment.locale(locale);
      if (persist) {
        try {
          window.localStorage.setItem(STORED_LOCALE_KEY, locale);
        } catch (e) { /* ignore storage errors (private mode, etc.) */ }
      }
    }
  }
};
